module.exports = __webpack_public_path__ + "static/media/Freezone Image SF 11263-1 & 11109-2 - 1340 x 650.b7b553c5.jpg";